export default __webpack_public_path__ + "img/landscape_custom.c3ca6b6d395923b00c0be0b1d9cc4afb.jpg";